import React from "react";
import { Mail, Phone } from "lucide-react";
import ModalNew from "../../../../components/Modal/ModalNew";

interface ContactSalesModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ContactSalesModal: React.FC<ContactSalesModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <ModalNew isOpen={isOpen} onClose={onClose} className="p-0">
      <div className="p-2">
        {/* <h3 className="text-[18px] font-semibold text-gray-900 mb-2 text-center">
          Contact Sales Team
        </h3> */}

        <div className="space-y-2">
          <a
            href="mailto:solutions@25thmail.com"
            className="flex items-center gap-3 w-full p-3 border border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-all group"
          >
            <div className="w-10 h-10 rounded-full bg-black/10 flex items-center justify-center text-black group-hover:bg-blue-600 group-hover:text-white transition-colors">
              <Mail className="w-5 h5" />
            </div>
            <div className="text-left">
              {/* <div className="font-semibold text-gray-900">Send an email</div> */}
              <div className="text-sm text-black">solutions@25thmail.com</div>
            </div>
          </a>

          <a
            href="tel:+2347068275230"
            className="flex items-center gap-3 w-full p-3 border border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-all group"
          >
            <div className="w-10 h-10 rounded-full bg-black/10 flex items-center justify-center text-black group-hover:bg-blue-600 group-hover:text-white transition-colors">
              <Phone className="w-5 h-5" />
            </div>
            <div className="text-left">
              {/* <div className="font-semibold text-gray-900">Make a call</div> */}
              <div className="text-sm text-black">+234 706 827 5230</div>
            </div>
          </a>
        </div>

        <button
          onClick={onClose}
          className="mt-2 w-full py-2.5 text-gray-500 hover:text-gray-900 font-medium text-sm"
        >
          Cancel
        </button>
      </div>
    </ModalNew>
  );
};

export default ContactSalesModal;
